import { GroupExpandableData } from './expandable-group.reducer';
import { ExpandableGroupService } from './expandable-group.service';
import { MbExpandablePanel, MbExpandablePanelTrigger, MbIcon } from '@am/moebius';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { NgIf } from '@angular/common';
import { FocusSelectComponent } from '../focus-select/focus-select.component';

@Component({
    selector: 'am-expandable-group',
    templateUrl: './am-expandable-group.component.html',
    styleUrls: ['./am-expandable-group.component.scss'],
    standalone: true,
    imports: [
        FocusSelectComponent,
        NgIf,
        MbExpandablePanel,
        MbExpandablePanelTrigger,
        MbIcon,
    ]
})
export class AmExpandableGroupComponent implements OnDestroy, AfterViewInit {
  @Input() set selectedExpandable(selected: boolean) {
    this.selected = selected;
  }
  @ViewChild('panelExpandable') mbExpandablePanel: MbExpandablePanel;
  @ViewChild('contentText') contentText: ElementRef;
  @ViewChild('bodyExpandable') bodyExpandable: ElementRef;

  public selected = false;
  private subscriptions: Subscription;

  @Input() name = '';
  @Input() size = '';
  constructor(
    private expandableGroupService: ExpandableGroupService,
    private render: Renderer2,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit() {
    this.subscriptions = this.expandableGroupService
      .listenChange()
      .subscribe((value: GroupExpandableData) => {
        let valueHeight = 0;
        console.log(value);
        if (value.group[this.name] !== undefined) {
          valueHeight = value.group[this.name].height;
          value.group[this.name].expanded
            ? this.mbExpandablePanel.open()
            : this.mbExpandablePanel.close();
        }
        this.render.setStyle(
          this.contentText.nativeElement,
          'height',
          `${valueHeight}px`,
        );
      });

    this.expandableGroupService.setHeight(this.name, this.getStyles());
    this.cdr.detectChanges();

    if (this.bodyExpandable.nativeElement !== undefined) {
      const staticExpandable =
        this.bodyExpandable.nativeElement.getElementsByClassName('static-expandable')[0];
      if (staticExpandable !== undefined) {
        if (staticExpandable.childNodes.length === 0) {
          this.render.setStyle(this.bodyExpandable.nativeElement, 'min-height', `0px`);
          this.render.setStyle(staticExpandable, 'display', 'none');
        } else {
          this.render.setStyle(this.bodyExpandable.nativeElement, 'min-height', `64px`);
          this.render.setStyle(staticExpandable, 'display', 'block');
        }
      }
      if (this.size === 'short') {
        this.render.setStyle(staticExpandable, 'height', '64px');
      }
    }
  }

  public openPanel() {
    this.cdr.detectChanges();
    if (this.mbExpandablePanel) {
      this.expandableGroupService.setExpanded(this.name, this.mbExpandablePanel.expanded());
    }
  }

  private getStyles() {
    let size = 0;
    if (this.contentText && this.mbExpandablePanel) {
      let sizeHeight = '';
      this.render.setStyle(this.contentText.nativeElement, 'height', `auto`);
      sizeHeight = getComputedStyle(this.contentText.nativeElement).height;
      size = sizeHeight.includes('px')
        ? parseInt(sizeHeight.slice(0, -2), 10)
        : this.contentText.nativeElement.offsetHeight;
    }

    return size;
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
